<template>
  <button type="submit"
    class="btn btn-primary btn-submit"
    v-bind:disabled="isSubmiting"
    v-bind:class="{ 'btn-default': isSubmiting }">
    <span class="loader vertical-align-middle loader-form"
      v-bind:class="loaderIconClass"
      v-if="isSubmiting">
    </span>
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    isSubmiting: {
      type: Boolean,
      default: false,
    },
    loaderIconClass: {
      type: String,
      default: 'loader-circle',
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// LoadingButton.vue?41958868